import { titleTierRouting } from './titleTier.js'

export const TITLE_TIER_LABELS = Object.freeze({
  ring_tier: 'Ring eligible',
  congrats_tier: 'Congratulations only',
  review_required: 'Award level review',
})

// Keep the shared policy pure and unchanged. This adapter accepts the raw API
// record, normalized board row or dossier without treating a UI flag as proof.
export function titleTierEvidence(record = {}) {
  const source = record?.titleTierEvidence || record?.raw || record || {}
  const raw = source.properties ? { ...source, ...source.properties } : source
  const canonical = Boolean(record?.titleTierEvidence || record?.raw || source.properties)
  const value = (key, fallback) => Object.hasOwn(raw, key) ? raw[key] : canonical ? undefined : fallback
  // Absent facts must stay absent: synthesizing an own undefined field would
  // incorrectly satisfy the shared policy's complete-source requirement.
  return Object.fromEntries(Object.entries({
    sr_level: value('sr_level', record.level),
    championship_name: value('championship_name', record.name),
    champion_title_line: value('champion_title_line', record.story?.titleLine),
    governing_body: value('governing_body', record.governingBody),
    sr_governing_body: value('sr_governing_body', record.governingBody),
    sr_title_tier: raw.sr_title_tier,
    _unreadable: raw._unreadable,
  }).filter(([, value]) => value !== undefined))
}

export function titleTierFor(record) { return titleTierRouting(titleTierEvidence(record)) }
export function titleTierLabel(record) { return TITLE_TIER_LABELS[titleTierFor(record).titleTier] }
export function titleTierCountsFor(records = []) {
  const counts = { total: records.length, ring_tier: 0, congrats_tier: 0, review_required: 0 }
  for (const record of records) counts[titleTierFor(record).titleTier]++
  return counts
}

export function titleTierAllowsVariant(record, key) {
  const { titleTier } = titleTierFor(record)
  return titleTier === 'ring_tier' || (titleTier === 'congrats_tier' && key === 'congratulations')
}
